export default __webpack_public_path__ + "home-bfa2d319df92812852410c3afde864fd.svg";